import { render, staticRenderFns } from "./listfdetails_main.vue?vue&type=template&id=1c059ab7&scoped=true"
import script from "./listfdetails_main.vue?vue&type=script&lang=js"
export * from "./listfdetails_main.vue?vue&type=script&lang=js"
import style0 from "./listfdetails_main.vue?vue&type=style&index=0&id=1c059ab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c059ab7",
  null
  
)

export default component.exports